import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppConfig, SystemHeader } from '../../service/DTOs';
import * as TF from '../../service/tradeflow';
import * as DTO from '../../service/DTOs';
import * as API from '../../service/apisvc';
import * as RB from 'react-bootstrap';
import * as Actions from '../../service/Actions';
import * as Dispatch from '../../service/Dispatcher';

import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';


type MatrixFromFilterProps<T extends DTO.Identifyable> = MatrixFormFilterState<T> & { xsrfToken?: string }
    & { titleOfElem: string } & { titlePlural: string }
    & { processAppend: (data: T | undefined) => Promise<void> } & { processRemove: (data: T | undefined) => Promise<void> } & { loadFilterState: () => Promise<T[]> }
    & { reloadFilterStateRecord?: (record: T) => Promise<T> }
    & { processRemoveAll?: () => Promise<void> } 
    & { getOptions: (query: string) => Promise<{ options: any }> }
    & { renderElement: (data: T) => any } & { lookupFilterBy: string[] } & { llokupLabelKey: string }
    & { renderLookupMenuItemChildren: (option: T, props: any, index: number) => JSX.Element }
    & { renderFilterTableRow: (data: T) => JSX.Element, selected_locatorId?: string }
    & { renderFilterTable: (records: T[], processing: boolean, rowRenderer: (data: T) => JSX.Element, selected_locatorId?: string) => any }
    ;

export interface MatrixFormFilterState<T extends DTO.Identifyable> {
    selected_locatorId?: string;
    holdFocus: boolean;


    isLoading: boolean;
    isSubmitting: boolean;
    processing: boolean;
    modified: boolean;
    haserrors: boolean;
    error?: string;
    result?: string;
    selected: boolean;
    elements?: T[];
    elemlookupoptions: any[];
    selectedElem?: T
}

export const initialstate_matrixfilter = {
    isLoading: false,
    isSubmitting: false,
    processing: false,
    haserrors: false,
    modified: false,
    selected: false,
    elemlookupoptions: [],
    holdFocus: false
}


export class MatrixFormFilter<T extends DTO.Identifyable> extends React.Component<MatrixFromFilterProps<T>, MatrixFormFilterState<T>> {
    typeahead: any;

    constructor(props: MatrixFromFilterProps<T>) {
        super(props);
        this.state = {
            ...initialstate_matrixfilter, ...{ processing: props.processing, haserrors: props.haserrors, modified: props.modified }
        };

        this.props.loadFilterState().then(data => {
            this.setState({ elements: data });
        });


    }

    handleRemove(locatorId?: string, record?: T) {
        return (async () => {
            //this.dispatch({ type: 'SUBMIT_NEW_ORDER_FORM', payload: form });
            try {
                this.setState({ isSubmitting: true, processing: true });

                await this.props.processRemove(record);

                var _elements = await this.props.loadFilterState();
                this.setState({ elements: _elements });

            } catch (error) {
                //this.dispatch({ type: 'NEW_ORDER_FORM_ERROR', payload: { form, result: error.message || 'Произошла ошибка' } });
            }
            finally {
                this.setState({ isSubmitting: false, processing: false });
            }

        })();
    }

    handleProcess(record?: T, process?: () => Promise<void> ) {
        return (async () => {
            //this.dispatch({ type: 'SUBMIT_NEW_ORDER_FORM', payload: form });
            try {
                //this.setState({ isSubmitting: true, processing: true });

                if (process)
                    await process();

                if (record && this.props.reloadFilterStateRecord) {
                    var elementRec = await this.props.reloadFilterStateRecord(record);
                    //console.log('reloaded data');
                    //console.log(elementRec);

                    if (this.state.elements) {
                        let elIdx = this.state.elements.findIndex(obj => { return obj.id == elementRec.id });
                        if (elIdx >= 0) {
                            var els = this.state.elements;
                            //els[elIdx] = elementRec;
                            this.state.elements[elIdx] = elementRec;

                            //this.forceUpdate();

                            //console.log('new ELS');
                            //console.log(els);
                            this.setState({ elements: els });
                        }
                    }

                    //this.setState({ elements: els });
                }

            } catch (error) {
                //this.dispatch({ type: 'NEW_ORDER_FORM_ERROR', payload: { form, result: error.message || 'Произошла ошибка' } });
            }
            finally {
                //console.log('handleProcess - final');
                //this.setState({ isSubmitting: false, processing: false });
            }

        })();
    }

    handleSelectContext(locatorId?: string, record?: T) {

        this.setState({
            selected_locatorId: locatorId
        });


        let uiCtx: DTO.UserInteractionContext = {
            selected_cmp: this,
            selected_locatorId: locatorId
        }

        TF.PublishCommand('COMMAND.UI.UserInteractionCtx', uiCtx);

        //if (locatorId && record) {
        //    let nOrder: DTO.NewOrder = record.proto;

        //    TF.PublishCommand('COMMAND.NewOrderFromTemplate', nOrder);
        //}
    }

    

    //dispatch = (action: Actions.OrderAction) => {
    //    return Dispatch.OrderDispatcher(this, action);
    //}


    //_accept = (locator: { locatorId: string }) => {
    //    //console.log('_repeal = ');
    //    //console.log(locator);

    //    let manipulation: DTO.ManipulationAction<string> = {
    //        locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
    //        type: DTO.MANIPULATION_PERM_TAKE,
    //        locatorId: locator.locatorId,
    //        payload: undefined
    //    }

    //    return Actions.orderActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatch);
    //}

    //componentWillReceiveProps(nextProps: OrderRecordProps) {
    //    this.setState(nextProps);
    //}

    //_onSelectOrder = (locatorId: string, record: DTO.RecordOrder) => {
    //    let manipulation: DTO.ManipulationAction<string> = {
    //        locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
    //        type: DTO.MANIPULATION_PERM_CONTEXT,
    //        locatorId: locatorId,
    //        payload: undefined
    //    }

    //    return this.props.orderSelected(locatorId, record);
    //}

    submitIncludeForm = (elem: T) => {
        return (async () => {
            //this.dispatch({ type: 'SUBMIT_NEW_ORDER_FORM', payload: form });
            try {
                this.setState({ isSubmitting: true });

                await this.props.processAppend(elem);

                var _elements = await this.props.loadFilterState();
                this.setState({ elements: _elements });

            } catch (error) {
                //this.dispatch({ type: 'NEW_ORDER_FORM_ERROR', payload: { form, result: error.message || 'Произошла ошибка' } });
            }
            finally {
                this.setState({ isSubmitting: false });
            }

        })();
    }

    includeElement = (event: React.FormEvent<RB.Form>) => {
        event.stopPropagation();

        if (this.state.selectedElem) {
            this.submitIncludeForm(this.state.selectedElem);
            event.preventDefault();
        }
    }


    //var rowpos = $('#table tr:last').position();

    //$('#container').scrollTop(rowpos.top);

    //getOptions = (query: string) => {

    //    return fetch(API.apiUrl(API.API_SECLOOKUP_URL) + "/" + `${query}` + ".json")
    //        .then((response) => {
    //            return response.json();
    //        }).then((json) => {
    //            return { options: json };
    //        });
    //}

    _handleElemSearch = (query: string) => {
        this.setState({ isLoading: true });
        this.props.getOptions(query)
            .then(({ options }) => {
                this.setState({
                    isLoading: false,
                    elemlookupoptions: options
                });
            });
    }

    _handleElemSelect = (elem: T[]) => {
        if (elem && elem.length > 0)
            this.setState({ selectedElem: elem[0] });
        else
            this.setState({ selectedElem: undefined });
    }

    setTypeaheadRef = (element: any) => {
        this.typeahead = element;
    };

    public render() {
        //console.log(this.props.record.manipulation);
        let bg_color = this.state.modified ? '#9be8d7' : (this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white'));
        //let row_border = this.state.selected ? { borderStyle: 'solid', borderWidth: '2.5px' } : { borderStyle: 'none' };

        //let crsr = this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_CONTEXT) ? { cursor: 'pointer' } : {};

        //var trStyle = {
        //    //...{ backgroundColor: bg_color }, ...row_border, ...crsr
        //    ...{ textAlign: 'right' }, ...{ backgroundColor: bg_color }, ...crsr
        //};

        var trClass = this.state.selected ? 'rowselected' : undefined;

        let selectedSetFrm = this.state.selectedElem
            ? this.props.renderElement(this.state.selectedElem)
            : <p className='rep_dimmedText'>{'Выберите элемент "' + this.props.titleOfElem + '"'}</p>;


        let resultCap =
            this.state.isSubmitting ?
                <div>{"Отправка данных"}</div>
                : !this.state.processing ?
                    (this.state.result === undefined ? ""
                        : !this.state.haserrors ?
                            <div><RB.Glyphicon glyph="glyphicon glyphicon-ok" />{" "}{this.state.result}</div>
                            : <div><RB.Glyphicon glyph="glyphicon glyphicon-exclamation-sign" />{" "}{this.state.error}</div>
                    )
                    : "";

        let filterContent = this.state.processing
            ? <p><em>Processing...</em></p>
            : (this.state.elements ? this.props.renderFilterTable(this.state.elements, this.state.processing ? this.state.processing : false, this.props.renderFilterTableRow, this.state.selected_locatorId)
                : this.props.renderFilterTable([], false, this.props.renderFilterTableRow, this.state.selected_locatorId));


        return <div >
            <RB.Row>
                <RB.Col sm={12}>
                    <RB.Row>
                        <RB.Col sm={12} className='otc-filter-hdr'>
                            {/*<span><b>{'Разрешенные ' + this.props.titlePlural + ': '}</b>{this.state.elements && this.state.elements.length > 0 ? '' + this.state.elements.length + ' элемент(ов)' : ' список пуст'}</span>*/}
                            <span><b>{this.props.titlePlural + ': '}</b>{this.state.elements && this.state.elements.length > 0 ? '' + this.state.elements.length + ' элемент(ов)' : ' список пуст'}</span>
                            {this.props.processRemoveAll ?
                                <RB.ButtonGroup bsSize="xsmall" style={{ marginLeft:'5px' }}>
                                        <RB.Button title='Очистить' onClick={() => { this.props.processRemoveAll ? this.props.processRemoveAll() : undefined; }}><RB.Glyphicon glyph="remove" />{' Очистить'}</RB.Button>
                                    </RB.ButtonGroup>
                                : undefined}
                        </RB.Col>
                    </RB.Row>
                    <RB.Row>
                        <RB.Col sm={12}>
                            <div>{filterContent}</div>
                        </RB.Col>
                    </RB.Row>

                    <RB.Row>
                        <RB.Col sm={12} className='otc-filter-hdr'>
                            <span><b>{'Добавление элемента:'}</b></span>
                        </RB.Col>
                    </RB.Row>
                    <RB.Row>
                        <RB.Col sm={12} >
                            <RB.Form horizontal method="post" onSubmit={this.includeElement} autoComplete="off">
                                <input type="hidden" name="requestVerificationToken" defaultValue={this.props.xsrfToken} />
                                <fieldset>

                                    <RB.FormGroup>
                                        <RB.Col sm={4} className='otc-inp-label'>
                                            {this.props.titleOfElem + ':'}
                                        </RB.Col>

                                        <RB.Col sm={7} smOffset={1}>

                                            <AsyncTypeahead
                                                {...this.state}
                                                ref={this.setTypeaheadRef}
                                                clearButton={false}
                                                selected={this.state.selectedElem ? [this.state.selectedElem] : []}
                                                promptText="Введите строку для поиска"
                                                searchText="Поиск..."
                                                emptyLabel="Совпадений не найдено"
                                                paginationText="Еще результаты..."
                                                //highlightOnlyResult={true}
                                                labelKey={this.props.llokupLabelKey}
                                                minLength={1}
                                                maxResults={50}
                                                onSearch={this._handleElemSearch}
                                                placeholder={'Поиск - ' + this.props.titleOfElem}
                                                align="right"
                                                filterBy={this.props.lookupFilterBy}

                                                renderMenuItemChildren={this.props.renderLookupMenuItemChildren}
                                                onChange={this._handleElemSelect}
                                                options={this.state.elemlookupoptions}
                                            />
                                        </RB.Col>
                                    </RB.FormGroup>

                                    <RB.FormGroup >

                                        <RB.Col sm={6}>
                                            <div style={{ fontSize: '12px' }}>
                                                {selectedSetFrm}
                                            </div>
                                        </RB.Col>

                                        <RB.Col sm={5} smOffset={1} className="text-center">
                                            <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.isSubmitting || !this.state.selectedElem}>
                                                <RB.Glyphicon glyph="plus" />{' Добавить'}
                                            </RB.Button>
                                        </RB.Col>
                                    </RB.FormGroup>
                                    <RB.FormGroup>
                                        <RB.Col sm={12} className="text-center">

                                            <div>
                                                {resultCap}
                                            </div>
                                        </RB.Col>
                                    </RB.FormGroup>

                                </fieldset>
                            </RB.Form>
                        </RB.Col>
                    </RB.Row>
                </RB.Col>
            </RB.Row>
        </div>;
    }

}





